import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default values => ({
  birthState: values.birthState ?? '',
  birthDate: values.birthDate
    ? momentLocalTimezone(values.birthDate)
    : momentLocalTimezone(),
  curp: values.curp ?? '',
  rfc: values.rfc ?? '',
  identificationNumber: values.identificationNumber ?? '',
  sex: values.sex || '',
  personType: values.personType || '',
  nationality: values.nationality || '',
  yearsOperating: values.yearsOperating || '',
  monthlyIncome: values.monthlyIncome || '',
  isDoctorWithTitle: values.isDoctorWithTitle || false
});
